import React from "react";

import TabPanel from "components/ApiTabPanel/ApiTabPanel";
import CodeCard from "components/shared/CodeCard.js";

export function TabPanelUpdate(props) {
  const { name, friendlyName, value, attributes, lineItems } = props;

  const includeCustomerNote = attributes.reduce((accumulator, attribute) =>
    (accumulator||attribute.name === "customer"), false);

  const includeVendorNote = attributes.reduce((accumulator, attribute) =>
    (accumulator||attribute.name === "vendor"), false);

  var includeItemNote = false;
  if (lineItems) {
    includeItemNote = lineItems.reduce((accumulator, attribute) =>
      (accumulator||attribute.name === "item"), false);
  }

  var refAttrs = [];
  if (includeCustomerNote) { refAttrs.push("Customer") }
  if (includeVendorNote) { refAttrs.push("Vendor") }
  if (includeItemNote) { refAttrs.push("Item") }

  const refString = refAttrs.join(", ");

  const endpointPhrase =
    refAttrs.length < 2
    ? "own API endpoint"
    : "respective API endpoints";

  return (
    <TabPanel value={value} index={4}>
      <div style={{ width: "66%" }}>
        <h3>Update</h3>
        <p>
          Updates a specific {friendlyName.toLowerCase()} by setting the values
          of the parameters passed. Use a query or read request to retrieve the
          object with all its attributes, and update those you want to change.
          Leave any unchanged attributes in the object; otherwise their values
          will be cleared. (You do not need to include read-only fields.)
        </p>
        <CodeCard>PUT /api/v2/{name.toLowerCase()}/:id</CodeCard>
        <p>Example:</p>
        <CodeCard>PUT /api/v2/{name.toLowerCase()}/123</CodeCard>
        {refString !== "" &&
          <p>
            Note that new referenced records ({refString}) cannot be created
            in this Create {friendlyName} transaction. New referenced records
            must be first created through their {endpointPhrase},
            then referenced here by ID when creating
            the {friendlyName} transaction.
          </p>
        }
        <p>This call returns the updated {name} object.</p>
      </div>
    </TabPanel>
  );
}
